var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-products-group" },
    [
      _vm.group.notification.title
        ? _c(
            "ui-notification",
            {
              staticClass: "group-notification",
              class: { "group-notification_flat": _vm.group.flat },
              attrs: {
                title: _vm.group.notification.title,
                color: _vm.group.notification.color
              }
            },
            [
              _vm.group.type === "pickup"
                ? _c(
                    "div",
                    { staticClass: "group-icon-store" },
                    [
                      _vm._v("\n      Магазин\n      "),
                      _c("f-sprite-icon", {
                        attrs: { "icon-link": _vm.$options.icons.IconLogo.id }
                      })
                    ],
                    1
                  )
                : _vm.group.type === "thirdparty"
                ? _c(
                    "div",
                    { staticClass: "group-icon-thirdparty" },
                    [
                      _vm.group.thirdPartyType === "postamat"
                        ? [
                            _c("f-sprite-icon", {
                              attrs: {
                                "icon-link": _vm.$options.icons.IconTerminal.id
                              }
                            })
                          ]
                        : [
                            _c("f-sprite-icon", {
                              attrs: {
                                "icon-link": _vm.$options.icons.IconPickup.id
                              }
                            })
                          ],
                      _c("span", [_vm._v(_vm._s(_vm.group.name))])
                    ],
                    2
                  )
                : _vm._e(),
              _c("span", { staticClass: "group-address" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.group.notification.subtitle) +
                    "\n    "
                )
              ]),
              _vm.group.actions.length
                ? _c(
                    "template",
                    { slot: "action" },
                    _vm._l(_vm.group.actions, function(a) {
                      return _c("ui-button", {
                        key: a.text,
                        class: [{ disabled: _vm.cartIsLoading }],
                        attrs: { text: a.text, flat: a.flat },
                        on: {
                          click: function($event) {
                            return a.click()
                          }
                        }
                      })
                    }),
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.groupIsOpened,
              expression: "groupIsOpened"
            }
          ],
          staticClass: "group-wrapper"
        },
        _vm._l(_vm.group.products, function(p) {
          return _c("checkout-product", {
            key: p.lineIds[0],
            attrs: {
              product: p,
              "shipping-group-id": _vm.group.id,
              editable: ""
            },
            on: {
              edit: function($event) {
                return _vm.$emit("edit", { product: p, group: _vm.group })
              }
            }
          })
        }),
        1
      ),
      _c(
        "div",
        {
          staticClass: "group-button",
          on: {
            click: function($event) {
              _vm.groupIsOpened = !_vm.groupIsOpened
            }
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.button) + "\n    "),
          _c("chevron-animated", { attrs: { reverse: _vm.groupIsOpened } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }